import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { authService } from '../services/authService'
import styled from 'styled-components'

const CallbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`

const MessageCard = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
`

function OAuthCallback() {
  const { login } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      console.log('🔄 Handling OAuth callback...')
      
      // Get token from URL fragment (hash) - e.g., #token=eyJhbGciOiJ...
      const hash = window.location.hash.substring(1) // Remove the '#'
      const params = new URLSearchParams(hash)
      const token = params.get('token')
      
      console.log('URL fragment:', hash.substring(0, 50) + '...')

      if (!token) {
        console.error('No authentication token found in URL')
        navigate('/login?error=no_token')
        return
      }

      try {
        console.log('Token received, validating...')
        
        // Store token immediately
        localStorage.setItem('token', token)
        
        // Try to get user info using the token
        try {
          const userData = await authService.getCurrentUser()
          console.log('User data retrieved:', userData)
          
          // Login with token and user data
          await login(token, userData)
          
          // Clear URL fragment for security
          window.history.replaceState(null, '', window.location.pathname)
          
          // Redirect to dashboard
          navigate('/')
          
        } catch (userError) {
          console.error('Failed to get user data:', userError)
          // Token might be invalid, clear it
          localStorage.removeItem('token')
          navigate('/login?error=token_invalid')
        }
        
      } catch (error) {
        console.error('Callback handling failed:', error)
        localStorage.removeItem('token')
        navigate('/login?error=callback_failed')
      }
    }

    handleCallback()
  }, [login, navigate])

  return (
    <CallbackContainer>
      <MessageCard>
        <h2>Completing Sign In...</h2>
        <p>Please wait while we finish setting up your account.</p>
        <div style={{ marginTop: '1rem' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #f3f4f6',
            borderTop: '4px solid #2563eb',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </MessageCard>
    </CallbackContainer>
  )
}

export default OAuthCallback
